import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { PanelCard } from "@sonder/ui/source/styled/fragments/PanelCard";
import { TextArea } from "@sonder/ui/source/styled/fragments/TextArea";
import { colors } from "@sonder/ui/source/styled/theme";
import { TaskData } from "core/queries/GetTask";
import { useUpdateTask } from "core/queries/UpdateTask";
import { ParsedText } from "tasks/components/ParsedText";

const StyledNotesCard = styled(PanelCard)`
  white-space: pre-line;
`;

export const StyledTextArea = styled(TextArea)`
  background: none;
  border: none;
  padding: 0;
  width: 100%;
`;

const TemporaryPlaceholder = styled.div`
  color: ${colors.gray6};
`;

export const NotesCard = ({ task }: { task: TaskData }) => {
  const [onUpdateTask] = useUpdateTask();
  const [text, setText] = useState(task.notes || "");
  const [isEditing, setIsEditing] = useState(false);
  const isTextEmpty = text.trim() === "";
  const placeholderText = "Notes for task";

  useEffect(() => {
    if (task.notes !== text) setText(task.notes || "");
  }, [task.notes]);

  return (
    <StyledNotesCard data-testid="notes-card">
      {isEditing ? (
        <StyledTextArea
          autoFocus
          data-testid="editable-notes"
          placeholder={placeholderText}
          value={text}
          onBlur={() => {
            onUpdateTask({ variables: { taskId: task.id, newNotes: text } });
            setIsEditing(false);
          }}
          onChange={e => setText(e.target.value)}
        />
      ) : (
        <div
          data-testid="non-editable-notes"
          onClick={() => setIsEditing(true)}
        >
          {isTextEmpty ? (
            <TemporaryPlaceholder>{placeholderText}</TemporaryPlaceholder>
          ) : (
            <ParsedText>{text}</ParsedText>
          )}
        </div>
      )}
    </StyledNotesCard>
  );
};
